const TOKEN_KEY = 'votebox_auth_token'
const WALLET_ADDRESS_KEY = 'votebox_wallet_address'

/**
 * Save authentication token to localStorage
 */
export const saveAuthToken = (token: string, walletAddress: string): void => {
  try {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(WALLET_ADDRESS_KEY, walletAddress)
  } catch (error) {
    throw new Error(`Authentication: Failed to save auth token: ${error}`)
  }
}

/**
 * Get authentication token from localStorage
 */
export const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch (error) {
    throw new Error(`Authentication: Failed to get auth token: ${error}`)
  }
}

/**
 * Get stored wallet address from localStorage
 */
export const getStoredWalletAddress = (): string | null => {
  try {
    return localStorage.getItem(WALLET_ADDRESS_KEY)
  } catch (error) {
    throw new Error(
      `Authentication: Failed to get stored wallet address: ${error}`,
    )
  }
}

/**
 * Remove authentication token from localStorage
 */
export const removeAuthToken = (): void => {
  try {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(WALLET_ADDRESS_KEY)
  } catch (error) {
    throw new Error(`Authentication: Failed to remove auth token: ${error}`)
  }
}

/**
 * Normalize wallet address for comparison (remove differences in format)
 */
const normalizeAddress = (address: string): string => {
  // TON addresses can be in different formats (bounceable/non-bounceable)
  // but the raw address (workchain:hash) should be the same
  return address.toLowerCase().trim()
}

/**
 * Check if user is authenticated (has valid token for current wallet)
 */
export const isAuthenticated = (currentWalletAddress?: string): boolean => {
  const token = getAuthToken()
  const storedAddress = getStoredWalletAddress()

  if (!token || !storedAddress) {
    return false
  }

  // If wallet address is provided, verify it matches stored address
  if (currentWalletAddress) {
    const normalizedStored = normalizeAddress(storedAddress)
    const normalizedCurrent = normalizeAddress(currentWalletAddress)

    if (normalizedStored !== normalizedCurrent) {
      // Wallet changed, remove old token
      removeAuthToken()
      return false
    }
  }

  return true
}
